import type { ReactNode } from 'react';
import { ConfigProvider, App as AntdApp, theme } from 'antd';
import zhCN from 'antd/locale/zh_CN';
import dayjs from 'dayjs';
import 'dayjs/locale/zh-cn';
import { useThemeStore } from '@/stores/theme';

dayjs.locale('zh-cn');

export function AntdProvider({ children }: { children: ReactNode }) {
  const navTheme = useThemeStore((s) => s.navTheme);
  const colorPrimary = useThemeStore((s) => s.colorPrimary);

  return (
    <ConfigProvider
      locale={zhCN}
      theme={{
        algorithm: navTheme === 'realDark' ? theme.darkAlgorithm : theme.defaultAlgorithm,
        token: {
          colorPrimary,
          borderRadius: 6,
        },
        components: {
          Table: { headerBg: navTheme === 'realDark' ? undefined : '#FAFAFA' },
          Card: { borderRadiusLG: 8 },
        },
      }}
    >
      <AntdApp>{children}</AntdApp>
    </ConfigProvider>
  );
}
